const getBoolValueFromEnv = key => {
    return JSON.parse(process.env[key])
}

const getDefaultValueFromEnv = key => {
    return process.env[key]
}

const getCustomerMediaUrl = getDefaultValueFromEnv('REACT_APP_CUSTOMER_MEDIA_URL')

export {getBoolValueFromEnv, getCustomerMediaUrl}
